import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const MobileSubtitle: FC<IOuter> = () => <FormattedMessage id="empty-state.mobile-folder-subtitle" />;
